export const DATA_LIMIT = 10;

export const DIMENSION_FIELDS_LIST: any = [
    {attribute: "name", label: "Name", cssClass: ''},
    {attribute: "width", label: "Width", cssClass: ''},
    {attribute: "height", label: "Height", cssClass: ''},
    {attribute: "isDefault", label: "Is Default", cssClass: '', isBoolean: true},
    {attribute: "isBlogPost", label: "Is Blog Post", cssClass: '', isBoolean: true},
    {attribute: "isFacebook", label: "Is Facebook", cssClass: '', isBoolean: true},
    {attribute: "isPinterest", label: "Is Pinterest", cssClass: '', isBoolean: true},
];


export const DIMENSION_INPUT_FIELDS: any = [
    {attribute: "name", label: "Name", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "width", label: "Width", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "height", label: "Height", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "isDefault", label: "Is Default", type: 'checkbox', group: 'detail', cssClass: ''},
    {attribute: "isBlogPost", label: "Is Blog Post", type: 'checkbox', group: 'detail', cssClass: ''},
    {attribute: "isFacebook", label: "Is Facebook", type: 'checkbox', group: 'detail', cssClass: ''},
    {attribute: "isPinterest", label: "Is Pinterest", type: 'checkbox', group: 'detail', cssClass: ''},
];
